/** Import job statuses that still need user attention or background work. */
export const ACTIVE_IMPORT_STATUSES = new Set([
  'QUEUED',
  'UPLOADED',
  'EXTRACTING',
  'ANALYZING',
  'GENERATING',
  'VALIDATING',
  'PENDING_REVIEW',
  'INDEXING',
]);

export const TERMINAL_IMPORT_STATUSES = new Set(['COMPLETED', 'FAILED', 'CANCELLED']);

export function normalizeImportStatus(status) {
  if (status == null) return '';
  return String(status).trim().toUpperCase();
}

export function isActiveImportJob(job) {
  const status = normalizeImportStatus(job?.status);
  if (!status) return false;
  return !TERMINAL_IMPORT_STATUSES.has(status);
}

export function parseImportListResponse(data) {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.items)) return data.items;
  if (data && Array.isArray(data.content)) return data.content;
  return [];
}

export function filterActiveImportJobs(jobs) {
  if (!Array.isArray(jobs)) return [];
  return jobs.filter(isActiveImportJob);
}

/** Queued and in-flight first; higher progress next. */
export function sortActiveImportJobs(jobs) {
  const order = (j) => {
    if (j.status === 'QUEUED') return 0;
    if (j.status === 'PENDING_REVIEW') return 2;
    return 1;
  };
  return [...jobs].sort((a, b) => {
    const d = order(a) - order(b);
    if (d !== 0) return d;
    return (b.progress || 0) - (a.progress || 0);
  });
}

export function isImportNeedsReview(job) {
  const status = normalizeImportStatus(job?.status);
  const stage = normalizeImportStatus(job?.stage);
  return status === 'PENDING_REVIEW' || stage === 'PENDING_REVIEW';
}

export function importStageLabel(job) {
  if (job?.status === 'QUEUED') return 'In queue';
  if (job?.status === 'PENDING_REVIEW') return 'Ready for review';
  if (job?.stage === 'PENDING_REVIEW') return 'Ready for review';
  const stage = job?.stage || job?.status || '';
  const map = {
    UPLOADED: 'Uploaded',
    EXTRACTING: 'Extracting text',
    EXTRACTING_OCR: 'OCR (scanned pages)',
    ANALYZING: 'Analyzing',
    GENERATING: 'Generating Q&A',
    VALIDATING: 'Validating',
    INDEXING: 'Indexing',
  };
  return map[stage] || stage.replace(/_/g, ' ').toLowerCase();
}
